import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { TableCounseling } from "./components";
import {
  GET_COUNSELING_BY_LECTURER,
} from "../APIS";
import LoadingBtn from "../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../Library/AlertNotif";
import { Error404 } from "../../../Library/LoaderPage";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];
const curr_emp_id = AuthDecode?.currentData?.entityid || "";

export function CounselingLect() {
  const [activeTab, setActiveTab] = useState(1);
  const [results, setResults] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const ReloadCounselingData = async () => {
    setResults({ loading: true, data: [], message: "" });
    const param_act = {
      empid: curr_emp_id,
    };
    const result = await GET_COUNSELING_BY_LECTURER(param_act);
    if (result.data && Object.values(result.data).length > 0) {
      const filteredData = result.data
      .filter(
        (item) =>
          item.student_activity && Object.keys(item.student_activity).length > 0
      )
      .map(item => {
        if (item.student_activity.id === "asc.student.activity.notactive") {
          return { ...item, event_status: "" };
        }
        return item;
      });
      const sortedData = filteredData.sort((a, b) => {
        return a.studentid.localeCompare(b.studentid);
      });
      setResults({ loading: false, data: sortedData, message: "" });
    } else {
      setResults({ loading: false, data: [], message: "" });
    }
  };
  
  useEffect(() => {
    ReloadCounselingData();
  }, []);
  return (
    <div id="counseling">
      <div
        className="alert alert-custom alert-white alert-shadow fade show gutter-b"
        role="alert"
      >
        <IconAlert />
        <div className="d-flex align-items-center mr-2 py-2">
          <h3 className="font-weight-bold mb-0 mr-10">Counseling Status</h3>
          <div className="d-lg-flex mr-3">
            <NavTab activeTab={activeTab} setTab={setActiveTab} />
          </div>
        </div>
      </div>

      {results.loading ? (
        <LoadingBtn />
      ) : results.message ? (
        <AlertNotif message={results.message} color="danger" />
      ) : Object.values(results.data).length > 0 ? (
        <TableCounseling data={results.data} activeTab={activeTab} />
      ) : (
        <Error404 />
      )}
    </div>
  );
}

const NavTab = ({ activeTab, setTab }) => {
  const navArr = [
    { id: 1, name: "All" },
    { id: 2, name: "Pending Approval" },
    { id: 3, name: "Approved" },
    { id: 4, name: "Canceled" },
  ];
  return (
    <div className="navi navi-hover navi-active navi-link-rounded navi-bold d-lg-flex flex-column flex-lg-row">
      {navArr.map((v, index) => (
        <div className="navi-item mr-2" key={index}>
          <span
            className={
              "navi-link cursor-pointer " +
              (activeTab === index ? "active" : "")
            }
            onClick={() => setTab(index)}
          >
            {v.name}
          </span>
        </div>
      ))}
      <div className="navi-item mr-2">
        <span
          className={
            "navi-link cursor-pointer " + (activeTab === 4 ? "active" : "")
          }
          onClick={() => setTab(4)}
        >
          No Activity
        </span>
      </div>
    </div>
  );
};

const IconAlert = () => {
  return (
    <div className="alert-icon">
      <span className="svg-icon svg-icon-primary svg-icon-xl">
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect x="0" y="0" width="24" height="24"></rect>
            <path
              d="M7.07744993,12.3040451 C7.72444571,13.0716094 8.54044565,13.6920474 9.46808594,14.1079953 L5,23 L4.5,18 L7.07744993,12.3040451 Z M14.5865511,14.2597864 C15.5319561,13.9019016 16.375416,13.3366121 17.0614026,12.6194459 L19.5,18 L19,23 L14.5865511,14.2597864 Z M12,3.55271368e-14 C12.8284271,3.53749572e-14 13.5,0.671572875 13.5,1.5 L13.5,4 L10.5,4 L10.5,1.5 C10.5,0.671572875 11.1715729,3.56793164e-14 12,3.55271368e-14 Z"
              fill="#000000"
              opacity="0.3"
            ></path>
            <path
              d="M12,10 C13.1045695,10 14,9.1045695 14,8 C14,6.8954305 13.1045695,6 12,6 C10.8954305,6 10,6.8954305 10,8 C10,9.1045695 10.8954305,10 12,10 Z M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z"
              fill="#000000"
              fillRule="nonzero"
            ></path>
          </g>
        </svg>
      </span>
    </div>
  );
};
